import { z } from "zod";

const mailTextSchema = z.object({
  subject: z.string().trim().min(1, "Bitte einen Betreff eingeben.").max(160).regex(/^[^\r\n]*$/, "Der Betreff darf keinen Zeilenumbruch enthalten."),
  intro: z.string().trim().min(1, "Bitte einen Einleitungstext eingeben.").max(5_000),
  action: z.string().trim().min(1, "Bitte eine Buttonbeschriftung eingeben.").max(80),
});

export const mailSettingsSchema = z.object({
  invitation: mailTextSchema,
  reset: mailTextSchema,
  footer: z.string().trim().max(5_000),
});

export type MailSettings = z.infer<typeof mailSettingsSchema>;
export const defaultMailSettings: MailSettings = {
  invitation: {
    subject: "Willkommen bei Calepia – Konto einrichten",
    intro: "Wählen Sie Ihr eigenes Passwort und schließen Sie den Vorgang ab.",
    action: "Konto einrichten",
  },
  reset: {
    subject: "Calepia – neues Passwort vergeben",
    intro: "Wählen Sie Ihr eigenes Passwort und schließen Sie den Vorgang ab.",
    action: "Passwort vergeben",
  },
  footer: "",
};
